/* Órbita · anillo 3D que gira con el scroll, pestañas del catálogo, tarjetas con inclinación 3D, destacado que se endereza, pasos que se voltean y carrito sin salir de la página. */
(function () {
  'use strict';
  if (window.Orbita) return;
  window.Orbita = {};
  var doc = document;
  var C = window.ObCart || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var all = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* Aviso */
  var toastEl = null, toastTimer = 0;
  function toast(msg, ok) {
    if (!toastEl) {
      toastEl = doc.createElement('div');
      toastEl.className = 'ob ob-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      doc.body.appendChild(toastEl);
    }
    toastEl.textContent = '';
    var t = doc.createElement('span');
    t.textContent = msg;
    toastEl.appendChild(t);
    if (ok) {
      var a = doc.createElement('a');
      a.href = C.cart || '/cart';
      a.textContent = 'Ver carrito';
      toastEl.appendChild(a);
    }
    toastEl.classList.toggle('is-error', !ok);
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3400);
  }

  /* Agregar al carrito sin salir */
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ob-add]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    fetch((C.add || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-ob-add')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar'); return j; }); })
      .then(function () { return fetch((C.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        doc.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'orbita', data: { itemCount: cart.item_count, source: 'orbita' } } }));
        b.classList.add('is-added');
        setTimeout(function () { b.classList.remove('is-added'); }, 1400);
        toast('Agregado al carrito', true);
      })
      .catch(function (err) { toast(err && err.message ? err.message : 'No se pudo agregar. Intenta de nuevo.', false); })
      .then(function () { b.removeAttribute('aria-busy'); });
  });

  /* Botón que baja a la siguiente sección */
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ob-next]') : null;
    if (!b) return;
    var sec = b.closest('.shopify-section') || b.closest('.ob');
    var next = sec ? sec.nextElementSibling : null;
    if (!next) return;
    e.preventDefault();
    var hh = parseFloat(getComputedStyle(doc.body).getPropertyValue('--header-height')) || 0;
    window.scrollTo({ top: next.getBoundingClientRect().top + window.scrollY - hh, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* Inclinación 3D con el mouse */
  function tilt(scope, sel, max) {
    if (!fine || reduce) return;
    all(sel, scope).forEach(function (c) {
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateX(' + (-y * max).toFixed(2) + 'deg) rotateY(' + (x * max * 1.2).toFixed(2) + 'deg) translateY(-4px)';
      });
      c.addEventListener('pointerleave', function () { c.style.transform = ''; });
    });
  }

  function reveal(items) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight;
    items = items.filter(function (it) { return it.getBoundingClientRect().top > vh * 0.92; });
    items.forEach(function (it) { it.classList.add('ob-pre'); });
    var io = new IntersectionObserver(function (entries) {
      entries.filter(function (en) { return en.isIntersecting; }).forEach(function (en, i) {
        en.target.style.transitionDelay = (i * 50) + 'ms';
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -5% 0px' });
    items.forEach(function (it) { io.observe(it); });
  }

  /* Reacciones al scroll */
  var scrollers = [];
  var raf = 0;
  function tick() {
    raf = 0;
    scrollers = scrollers.filter(function (s) { return s.el.isConnected; });
    scrollers.forEach(function (s) { s.fn(); });
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function initHero(el) {
    var stage = el.querySelector('.ob-stage');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { entries.forEach(function (en) { el.classList.toggle('is-paused', !en.isIntersecting); }); }).observe(el);
    }
    if (reduce || !stage) return;
    scrollers.push({ el: el, fn: function () {
      var r = el.getBoundingClientRect();
      stage.style.setProperty('--ob-turn', (clamp(-r.top, -400, 2000) * 0.18).toFixed(1) + 'deg');
    } });
    if (fine) {
      el.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = clamp((e.clientX - r.left) / r.width - 0.5, -0.5, 0.5), y = clamp((e.clientY - r.top) / r.height - 0.5, -0.5, 0.5);
        stage.style.setProperty('--ob-ry', (x * 14).toFixed(2) + 'deg');
        stage.style.setProperty('--ob-rx', (-y * 10).toFixed(2) + 'deg');
      });
      el.addEventListener('pointerleave', function () { stage.style.setProperty('--ob-ry', '0deg'); stage.style.setProperty('--ob-rx', '0deg'); });
    }
  }

  function initTabs(el) {
    var tabs = all('[data-ob-tab]', el);
    var panes = all('[data-ob-pane]', el);
    var ink = el.querySelector('.ob-tabs__ink');
    function moveInk(t) {
      if (!ink || !t) return;
      ink.style.width = t.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + t.offsetLeft + 'px)';
    }
    function show(i) {
      tabs.forEach(function (t) { var on = t.getAttribute('data-ob-tab') === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); if (on) moveInk(t); });
      panes.forEach(function (p) {
        var on = p.getAttribute('data-ob-pane') === i;
        p.hidden = !on;
        p.classList.toggle('is-on', on);
        if (on && !reduce) {
          all('.ob-grid__item', p).forEach(function (it, k) {
            it.classList.add('ob-pre');
            it.classList.remove('is-in');
            it.style.transitionDelay = (k * 45) + 'ms';
            requestAnimationFrame(function () { requestAnimationFrame(function () { it.classList.add('is-in'); }); });
          });
        }
      });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-ob-tab')); }); });
    moveInk(el.querySelector('.ob-tab.is-on'));
    window.addEventListener('resize', function () { moveInk(el.querySelector('.ob-tab.is-on')); });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { moveInk(el.querySelector('.ob-tab.is-on')); });
    reveal(all('.ob-grid.is-on .ob-grid__item', el));
    tilt(el, '.ob-card', 7);
  }

  function initCat(el) {
    reveal(all('.ob-grid__item', el));
    tilt(el, '.ob-card', 7);
  }

  function initSpot(el) {
    var card = el.querySelector('.ob-spot__card');
    if (reduce || !card) return;
    scrollers.push({ el: el, fn: function () {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      card.style.setProperty('--ob-p', clamp((vh - r.top) / (vh * 0.7), 0, 1).toFixed(3));
    } });
  }

  function initSteps(el) {
    var cards = all('.ob-flip', el);
    cards.forEach(function (c) {
      c.addEventListener('click', function () { c.classList.toggle('is-flipped'); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.classList.toggle('is-flipped'); } });
    });
    if (reduce || !('IntersectionObserver' in window)) { cards.forEach(function (c) { c.classList.add('is-flipped'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var i = cards.indexOf(en.target);
        setTimeout(function () { en.target.classList.add('is-flipped'); }, 350 + (window.innerWidth >= 860 ? i * 450 : 0));
        io.unobserve(en.target);
      });
    }, { threshold: 0.6 });
    cards.forEach(function (c) { io.observe(c); });
  }

  var INIT = { hero: initHero, tabs: initTabs, cat: initCat, spot: initSpot, steps: initSteps };
  function boot(scope) {
    all('[data-ob]', scope).forEach(function (el) {
      if (el.__ob) return;
      el.__ob = true;
      var fn = INIT[el.getAttribute('data-ob')];
      if (fn) { try { fn(el); } catch (err) { console.warn('Órbita', err); } }
    });
    tick();
  }
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(doc); });
  else boot(doc);
})();
